// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/ReleaseModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { StringValue } from "../../../google/protobuf/wrappers";

export const protobufPackage = "daisi.protos.v1";

export interface HostReleaseInfo {
  Id: string;
  ReleaseGroup: string;
  Version: string;
  DownloadUrl: string;
  IsActive: boolean;
  ReleaseNotes?: string | undefined;
  RequiredOrcVersion?: string | undefined;
  CreatedBy?: string | undefined;
  DateCreated?: Date | undefined;
}

export interface CreateReleaseRequest {
  ReleaseGroup: string;
  Version: string;
  DownloadUrl: string;
  ReleaseNotes?: string | undefined;
  RequiredOrcVersion?: string | undefined;
  Activate: boolean;
}

export interface CreateReleaseResponse {
  Release?: HostReleaseInfo | undefined;
}

export interface GetReleasesRequest {
  ReleaseGroup: string;
}

export interface GetReleasesResponse {
  Releases: HostReleaseInfo[];
}

export interface GetActiveReleaseRequest {
  ReleaseGroup: string;
}

export interface GetActiveReleaseResponse {
  Release?: HostReleaseInfo | undefined;
}

export interface ActivateReleaseRequest {
  ReleaseId: string;
  ReleaseGroup: string;
}

export interface ActivateReleaseResponse {
  Release?: HostReleaseInfo | undefined;
}

export interface TriggerReleaseRequest {
  ReleaseGroup: string;
  ReleaseNotes?: string | undefined;
  Activate: boolean;
}

export interface TriggerReleaseResponse {
  Success: boolean;
  Version: string;
  ErrorMessage?: string | undefined;
}

function createBaseHostReleaseInfo(): HostReleaseInfo {
  return {
    Id: "",
    ReleaseGroup: "",
    Version: "",
    DownloadUrl: "",
    IsActive: false,
    ReleaseNotes: undefined,
    RequiredOrcVersion: undefined,
    CreatedBy: undefined,
    DateCreated: undefined,
  };
}

export const HostReleaseInfo: MessageFns<HostReleaseInfo> = {
  encode(message: HostReleaseInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.ReleaseGroup !== "") {
      writer.uint32(18).string(message.ReleaseGroup);
    }
    if (message.Version !== "") {
      writer.uint32(26).string(message.Version);
    }
    if (message.DownloadUrl !== "") {
      writer.uint32(34).string(message.DownloadUrl);
    }
    if (message.IsActive !== false) {
      writer.uint32(40).bool(message.IsActive);
    }
    if (message.ReleaseNotes !== undefined) {
      StringValue.encode({ value: message.ReleaseNotes! }, writer.uint32(50).fork()).join();
    }
    if (message.RequiredOrcVersion !== undefined) {
      StringValue.encode({ value: message.RequiredOrcVersion! }, writer.uint32(58).fork()).join();
    }
    if (message.CreatedBy !== undefined) {
      StringValue.encode({ value: message.CreatedBy! }, writer.uint32(66).fork()).join();
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HostReleaseInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostReleaseInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.DownloadUrl = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.IsActive = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ReleaseNotes = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.RequiredOrcVersion = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.CreatedBy = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HostReleaseInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "",
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      DownloadUrl: isSet(object.DownloadUrl) ? globalThis.String(object.DownloadUrl) : "",
      IsActive: isSet(object.IsActive) ? globalThis.Boolean(object.IsActive) : false,
      ReleaseNotes: isSet(object.ReleaseNotes) ? String(object.ReleaseNotes) : undefined,
      RequiredOrcVersion: isSet(object.RequiredOrcVersion) ? String(object.RequiredOrcVersion) : undefined,
      CreatedBy: isSet(object.CreatedBy) ? String(object.CreatedBy) : undefined,
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
    };
  },

  toJSON(message: HostReleaseInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.DownloadUrl !== "") {
      obj.DownloadUrl = message.DownloadUrl;
    }
    if (message.IsActive !== false) {
      obj.IsActive = message.IsActive;
    }
    if (message.ReleaseNotes !== undefined) {
      obj.ReleaseNotes = message.ReleaseNotes;
    }
    if (message.RequiredOrcVersion !== undefined) {
      obj.RequiredOrcVersion = message.RequiredOrcVersion;
    }
    if (message.CreatedBy !== undefined) {
      obj.CreatedBy = message.CreatedBy;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HostReleaseInfo>, I>>(base?: I): HostReleaseInfo {
    return HostReleaseInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HostReleaseInfo>, I>>(object: I): HostReleaseInfo {
    const message = createBaseHostReleaseInfo();
    message.Id = object.Id ?? "";
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    message.Version = object.Version ?? "";
    message.DownloadUrl = object.DownloadUrl ?? "";
    message.IsActive = object.IsActive ?? false;
    message.ReleaseNotes = object.ReleaseNotes ?? undefined;
    message.RequiredOrcVersion = object.RequiredOrcVersion ?? undefined;
    message.CreatedBy = object.CreatedBy ?? undefined;
    message.DateCreated = object.DateCreated ?? undefined;
    return message;
  },
};

function createBaseCreateReleaseRequest(): CreateReleaseRequest {
  return {
    ReleaseGroup: "",
    Version: "",
    DownloadUrl: "",
    ReleaseNotes: undefined,
    RequiredOrcVersion: undefined,
    Activate: false,
  };
}

export const CreateReleaseRequest: MessageFns<CreateReleaseRequest> = {
  encode(message: CreateReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ReleaseGroup !== "") {
      writer.uint32(10).string(message.ReleaseGroup);
    }
    if (message.Version !== "") {
      writer.uint32(18).string(message.Version);
    }
    if (message.DownloadUrl !== "") {
      writer.uint32(26).string(message.DownloadUrl);
    }
    if (message.ReleaseNotes !== undefined) {
      StringValue.encode({ value: message.ReleaseNotes! }, writer.uint32(34).fork()).join();
    }
    if (message.RequiredOrcVersion !== undefined) {
      StringValue.encode({ value: message.RequiredOrcVersion! }, writer.uint32(42).fork()).join();
    }
    if (message.Activate !== false) {
      writer.uint32(48).bool(message.Activate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.DownloadUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ReleaseNotes = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.RequiredOrcVersion = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.Activate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateReleaseRequest {
    return {
      ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "",
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      DownloadUrl: isSet(object.DownloadUrl) ? globalThis.String(object.DownloadUrl) : "",
      ReleaseNotes: isSet(object.ReleaseNotes) ? String(object.ReleaseNotes) : undefined,
      RequiredOrcVersion: isSet(object.RequiredOrcVersion) ? String(object.RequiredOrcVersion) : undefined,
      Activate: isSet(object.Activate) ? globalThis.Boolean(object.Activate) : false,
    };
  },

  toJSON(message: CreateReleaseRequest): unknown {
    const obj: any = {};
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.DownloadUrl !== "") {
      obj.DownloadUrl = message.DownloadUrl;
    }
    if (message.ReleaseNotes !== undefined) {
      obj.ReleaseNotes = message.ReleaseNotes;
    }
    if (message.RequiredOrcVersion !== undefined) {
      obj.RequiredOrcVersion = message.RequiredOrcVersion;
    }
    if (message.Activate !== false) {
      obj.Activate = message.Activate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateReleaseRequest>, I>>(base?: I): CreateReleaseRequest {
    return CreateReleaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateReleaseRequest>, I>>(object: I): CreateReleaseRequest {
    const message = createBaseCreateReleaseRequest();
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    message.Version = object.Version ?? "";
    message.DownloadUrl = object.DownloadUrl ?? "";
    message.ReleaseNotes = object.ReleaseNotes ?? undefined;
    message.RequiredOrcVersion = object.RequiredOrcVersion ?? undefined;
    message.Activate = object.Activate ?? false;
    return message;
  },
};

function createBaseCreateReleaseResponse(): CreateReleaseResponse {
  return { Release: undefined };
}

export const CreateReleaseResponse: MessageFns<CreateReleaseResponse> = {
  encode(message: CreateReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Release !== undefined) {
      HostReleaseInfo.encode(message.Release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Release = HostReleaseInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateReleaseResponse {
    return { Release: isSet(object.Release) ? HostReleaseInfo.fromJSON(object.Release) : undefined };
  },

  toJSON(message: CreateReleaseResponse): unknown {
    const obj: any = {};
    if (message.Release !== undefined) {
      obj.Release = HostReleaseInfo.toJSON(message.Release);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateReleaseResponse>, I>>(base?: I): CreateReleaseResponse {
    return CreateReleaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateReleaseResponse>, I>>(object: I): CreateReleaseResponse {
    const message = createBaseCreateReleaseResponse();
    message.Release = (object.Release !== undefined && object.Release !== null)
      ? HostReleaseInfo.fromPartial(object.Release)
      : undefined;
    return message;
  },
};

function createBaseGetReleasesRequest(): GetReleasesRequest {
  return { ReleaseGroup: "" };
}

export const GetReleasesRequest: MessageFns<GetReleasesRequest> = {
  encode(message: GetReleasesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ReleaseGroup !== "") {
      writer.uint32(10).string(message.ReleaseGroup);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetReleasesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetReleasesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetReleasesRequest {
    return { ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "" };
  },

  toJSON(message: GetReleasesRequest): unknown {
    const obj: any = {};
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetReleasesRequest>, I>>(base?: I): GetReleasesRequest {
    return GetReleasesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetReleasesRequest>, I>>(object: I): GetReleasesRequest {
    const message = createBaseGetReleasesRequest();
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    return message;
  },
};

function createBaseGetReleasesResponse(): GetReleasesResponse {
  return { Releases: [] };
}

export const GetReleasesResponse: MessageFns<GetReleasesResponse> = {
  encode(message: GetReleasesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Releases) {
      HostReleaseInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetReleasesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetReleasesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Releases.push(HostReleaseInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetReleasesResponse {
    return {
      Releases: globalThis.Array.isArray(object?.Releases)
        ? object.Releases.map((e: any) => HostReleaseInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetReleasesResponse): unknown {
    const obj: any = {};
    if (message.Releases?.length) {
      obj.Releases = message.Releases.map((e) => HostReleaseInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetReleasesResponse>, I>>(base?: I): GetReleasesResponse {
    return GetReleasesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetReleasesResponse>, I>>(object: I): GetReleasesResponse {
    const message = createBaseGetReleasesResponse();
    message.Releases = object.Releases?.map((e) => HostReleaseInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetActiveReleaseRequest(): GetActiveReleaseRequest {
  return { ReleaseGroup: "" };
}

export const GetActiveReleaseRequest: MessageFns<GetActiveReleaseRequest> = {
  encode(message: GetActiveReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ReleaseGroup !== "") {
      writer.uint32(10).string(message.ReleaseGroup);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActiveReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveReleaseRequest {
    return { ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "" };
  },

  toJSON(message: GetActiveReleaseRequest): unknown {
    const obj: any = {};
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveReleaseRequest>, I>>(base?: I): GetActiveReleaseRequest {
    return GetActiveReleaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveReleaseRequest>, I>>(object: I): GetActiveReleaseRequest {
    const message = createBaseGetActiveReleaseRequest();
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    return message;
  },
};

function createBaseGetActiveReleaseResponse(): GetActiveReleaseResponse {
  return { Release: undefined };
}

export const GetActiveReleaseResponse: MessageFns<GetActiveReleaseResponse> = {
  encode(message: GetActiveReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Release !== undefined) {
      HostReleaseInfo.encode(message.Release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActiveReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActiveReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Release = HostReleaseInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActiveReleaseResponse {
    return { Release: isSet(object.Release) ? HostReleaseInfo.fromJSON(object.Release) : undefined };
  },

  toJSON(message: GetActiveReleaseResponse): unknown {
    const obj: any = {};
    if (message.Release !== undefined) {
      obj.Release = HostReleaseInfo.toJSON(message.Release);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetActiveReleaseResponse>, I>>(base?: I): GetActiveReleaseResponse {
    return GetActiveReleaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetActiveReleaseResponse>, I>>(object: I): GetActiveReleaseResponse {
    const message = createBaseGetActiveReleaseResponse();
    message.Release = (object.Release !== undefined && object.Release !== null)
      ? HostReleaseInfo.fromPartial(object.Release)
      : undefined;
    return message;
  },
};

function createBaseActivateReleaseRequest(): ActivateReleaseRequest {
  return { ReleaseId: "", ReleaseGroup: "" };
}

export const ActivateReleaseRequest: MessageFns<ActivateReleaseRequest> = {
  encode(message: ActivateReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ReleaseId !== "") {
      writer.uint32(10).string(message.ReleaseId);
    }
    if (message.ReleaseGroup !== "") {
      writer.uint32(18).string(message.ReleaseGroup);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivateReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivateReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ReleaseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivateReleaseRequest {
    return {
      ReleaseId: isSet(object.ReleaseId) ? globalThis.String(object.ReleaseId) : "",
      ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "",
    };
  },

  toJSON(message: ActivateReleaseRequest): unknown {
    const obj: any = {};
    if (message.ReleaseId !== "") {
      obj.ReleaseId = message.ReleaseId;
    }
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActivateReleaseRequest>, I>>(base?: I): ActivateReleaseRequest {
    return ActivateReleaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActivateReleaseRequest>, I>>(object: I): ActivateReleaseRequest {
    const message = createBaseActivateReleaseRequest();
    message.ReleaseId = object.ReleaseId ?? "";
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    return message;
  },
};

function createBaseActivateReleaseResponse(): ActivateReleaseResponse {
  return { Release: undefined };
}

export const ActivateReleaseResponse: MessageFns<ActivateReleaseResponse> = {
  encode(message: ActivateReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Release !== undefined) {
      HostReleaseInfo.encode(message.Release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivateReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivateReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Release = HostReleaseInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivateReleaseResponse {
    return { Release: isSet(object.Release) ? HostReleaseInfo.fromJSON(object.Release) : undefined };
  },

  toJSON(message: ActivateReleaseResponse): unknown {
    const obj: any = {};
    if (message.Release !== undefined) {
      obj.Release = HostReleaseInfo.toJSON(message.Release);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActivateReleaseResponse>, I>>(base?: I): ActivateReleaseResponse {
    return ActivateReleaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActivateReleaseResponse>, I>>(object: I): ActivateReleaseResponse {
    const message = createBaseActivateReleaseResponse();
    message.Release = (object.Release !== undefined && object.Release !== null)
      ? HostReleaseInfo.fromPartial(object.Release)
      : undefined;
    return message;
  },
};

function createBaseTriggerReleaseRequest(): TriggerReleaseRequest {
  return { ReleaseGroup: "", ReleaseNotes: undefined, Activate: false };
}

export const TriggerReleaseRequest: MessageFns<TriggerReleaseRequest> = {
  encode(message: TriggerReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ReleaseGroup !== "") {
      writer.uint32(10).string(message.ReleaseGroup);
    }
    if (message.ReleaseNotes !== undefined) {
      StringValue.encode({ value: message.ReleaseNotes! }, writer.uint32(18).fork()).join();
    }
    if (message.Activate !== false) {
      writer.uint32(24).bool(message.Activate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTriggerReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ReleaseGroup = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ReleaseNotes = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.Activate = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TriggerReleaseRequest {
    return {
      ReleaseGroup: isSet(object.ReleaseGroup) ? globalThis.String(object.ReleaseGroup) : "",
      ReleaseNotes: isSet(object.ReleaseNotes) ? String(object.ReleaseNotes) : undefined,
      Activate: isSet(object.Activate) ? globalThis.Boolean(object.Activate) : false,
    };
  },

  toJSON(message: TriggerReleaseRequest): unknown {
    const obj: any = {};
    if (message.ReleaseGroup !== "") {
      obj.ReleaseGroup = message.ReleaseGroup;
    }
    if (message.ReleaseNotes !== undefined) {
      obj.ReleaseNotes = message.ReleaseNotes;
    }
    if (message.Activate !== false) {
      obj.Activate = message.Activate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TriggerReleaseRequest>, I>>(base?: I): TriggerReleaseRequest {
    return TriggerReleaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TriggerReleaseRequest>, I>>(object: I): TriggerReleaseRequest {
    const message = createBaseTriggerReleaseRequest();
    message.ReleaseGroup = object.ReleaseGroup ?? "";
    message.ReleaseNotes = object.ReleaseNotes ?? undefined;
    message.Activate = object.Activate ?? false;
    return message;
  },
};

function createBaseTriggerReleaseResponse(): TriggerReleaseResponse {
  return { Success: false, Version: "", ErrorMessage: undefined };
}

export const TriggerReleaseResponse: MessageFns<TriggerReleaseResponse> = {
  encode(message: TriggerReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Version !== "") {
      writer.uint32(18).string(message.Version);
    }
    if (message.ErrorMessage !== undefined) {
      StringValue.encode({ value: message.ErrorMessage! }, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TriggerReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTriggerReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ErrorMessage = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TriggerReleaseResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Version: isSet(object.Version) ? globalThis.String(object.Version) : "",
      ErrorMessage: isSet(object.ErrorMessage) ? String(object.ErrorMessage) : undefined,
    };
  },

  toJSON(message: TriggerReleaseResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Version !== "") {
      obj.Version = message.Version;
    }
    if (message.ErrorMessage !== undefined) {
      obj.ErrorMessage = message.ErrorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TriggerReleaseResponse>, I>>(base?: I): TriggerReleaseResponse {
    return TriggerReleaseResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TriggerReleaseResponse>, I>>(object: I): TriggerReleaseResponse {
    const message = createBaseTriggerReleaseResponse();
    message.Success = object.Success ?? false;
    message.Version = object.Version ?? "";
    message.ErrorMessage = object.ErrorMessage ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
